import { toast } from 'react-toastify';
import ApiBase from "./base";
import { LocalStorageKey } from '../shared/enums'
import i18n from "../translations";
import { jsonToQueryString } from '../shared/utils';

export const _USER_URL = "user";

export async function login(params) {
    const response = await ApiBase.post(`${_USER_URL}/login/portal`, params);

    if (response.success) {
        localStorage.setItem(LocalStorageKey.TOKEN, response.token)
        const data = response.user
        localStorage.setItem(LocalStorageKey.USER_DATA, JSON.stringify({
            id: data.id,
            fullName: data.fullName,
            gender: data.gender,
            email: data.email,
            countryCode: data.countryCode,
            phoneNumber: data.phoneNumber,
            serviceAreas: data.serviceAreas,
            roles: data.roles.map(role => role.name),
            permissions: data.roles.map(role => role.permission).reduce((acc, obj) => {
                const permissionObj = obj;
                for (const [key, value] of Object.entries(permissionObj)) {
                    if (!acc[key]) {
                        acc[key] = value;
                    } else {
                        acc[key] = [...new Set([...acc[key], ...value])];
                    }
                }
                return acc;
            }, {})
        }))
        toast.success(i18n.t("SUCCESS_TO_LOGIN"))
    }

    return response;
}


export async function getAllUserList(params) {
    const response = await ApiBase.get(`all-${_USER_URL}?${jsonToQueryString(params)}`);

    return response;
}

export async function getUserList(params) {
    const response = await ApiBase.get(`${_USER_URL}?${jsonToQueryString(params)}`);

    return response;
}

export async function getUserDetail(id) {
    const response = await ApiBase.get(`${_USER_URL}/${id}`);

    return response;
}

export async function createUser(params) {
    const response = await ApiBase.post(`${_USER_URL}`, params);
    if (response.success) toast.success(i18n.t("SUCCESS_TO_CREATE_USER"))

    return response;
}

export async function updateUser(id, params) {
    const response = await ApiBase.put(`${_USER_URL}/${id}`, params);
    if (response.success) toast.success(i18n.t("SUCCESS_TO_UPDATE_USER"))

    return response;
}
